import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router';
import qs from 'qs';

import i18n from '@/settings/i18n';
import { SortValue } from '../types';
import { Sorter } from '../Presentaition';

const sortValues: SortValue[] = [
  {
    label: i18n.t('models.subscription.orderBy.startsOnDesc'),
    value: '-starts_on',
  },
  {
    label: i18n.t('models.subscription.orderBy.startsOnAsc'),
    value: 'starts_on',
  },
];

export const SorterContainer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectFromSearch = useCallback(() => {
    const orderBy = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    }).order_by;
    return sortValues.find((s) => s.value === orderBy) || sortValues[0];
  }, [location.search]);

  const [current, setCurrent] = useState<SortValue>(selectFromSearch());

  const onChange = useCallback(
    (orderBy: SortValue['value']) => {
      const search = {
        ...qs.parse(location.search, { ignoreQueryPrefix: true }),
        order_by: orderBy,
      };
      navigate({
        pathname: location.pathname,
        search: qs.stringify(search),
      });
    },
    [location.pathname, location.search, navigate],
  );

  useEffect(() => {
    const current = selectFromSearch();
    setCurrent(current);
  }, [location, selectFromSearch]);

  const childProps = { current, sortValues, onChange };
  return <Sorter {...childProps} />;
};
